module.exports = __webpack_public_path__ + "img/about_image1.7c400af1.png";